var exports = {
  "k": "x234b8571--8d1028--container",
};

module.exports = exports;
